<script setup lang="ts">
const sheetController = useNewSheetController();

defineProps({
  submittedDocumentId: {
    type: String,
    required: true,
  },
  revisionId: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <div>
    <BaseSheetComponent :controller="sheetController" width="500px">
      <template #trigger>
        <BaseIconButton variant="text" v-tooltip="'View Editing History'">
          <BaseIconHistory class="h-3.5 w-3.5 shrink-0 text-gray-600" />
        </BaseIconButton>
      </template>
      <template #content>
        <DocumentEditingHistoryContainer
          :submitted-document-id="submittedDocumentId"
          :revision-id="revisionId"
          :sheet-controller="sheetController"
        />
      </template>
    </BaseSheetComponent>
  </div>
</template>

<style scoped></style>
